import React, { useState, useEffect } from 'react';

import { Button, TextField, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Container from './Container';
import CustomRadio from './CustomRadio';
import Question from './Question';
import Upload from './Upload';
import Documents from './Documents';

import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import { instanceAxios } from '../../InstanceAxios';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  input: {
    display: 'none',
  },
  margin: {
    margin: theme.spacing(1),
  },
  paper2: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '35%',
    height: '35%',
    overflow: 'auto',
  },
}));

function DocumentosIRPF() {
  const classes = useStyles();

  const [idServico, setIdServico] = useState(0);

  const [openModalUpload, setOpenModalUpload] = useState(false);
  const [openModalDocs, setOpenModalDocs] = useState(false);
  // const [userId, setUserId] = useState("");

  const [declaracaoAnterior, setDeclaracaoAnterior] = useState('Não');
  const [fileDeclaracaoAnterior, setFileDeclaracaoAnterior] = useState('');

  const [informesRendimentos, setInformesRendimentos] = useState('Não');
  const [fileInformesRendimentos, setFileInformesRendimentos] = useState('Não');

  const [informesBancarios, setInformesBancarios] = useState('Não');
  const [notasCorretagem, setNotasCorretagem] = useState('Não');
  const [bensAutomovel, setBensAutomovel] = useState('Não');
  const [bensImovel, setBensImovel] = useState('Não');
  const [bensParticipacao, setBensParticipacao] = useState('Não');
  const [comprovanteEndereco, setComprovanteEndereco] = useState('Não');
  const [dependentes, setDependentes] = useState('Não');
  const [despesas, setDespesas] = useState('Não');
  const [reciboPagamentos, setReciboPagamentos] = useState('Não');
  const [contribuicao, setContribuicao] = useState('Não');
  const [doacao, setDoacao] = useState('Não');
  const [comprovanteReceitas, setComprovanteReceitas] = useState('Não');
  const [pensao, setPensao] = useState('Não');
  const [carneLeao, setCarneLeao] = useState('Não');
  const [dadosPessoais, setDadosPessoais] = useState('Não');
  // const [valorCartao, setValorCartao] = useState("Não");

  function handleSubmit(event) {
    event.preventDefault();

    console.log('enviou');
  }

  useEffect(() => {
    getServiceID();
  }, []);

  async function getServiceID() {
    const userLocalId = localStorage.getItem('idadmin');

    const response = await instanceAxios(localStorage.getItem('toobiauth')).get(
      `/servicoContratadoIRPF/${userLocalId}`
    );

    setIdServico(response.data.id);
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={declaracaoAnterior}
              setValue={setDeclaracaoAnterior}
            />
            <Question>
              Declaração de imposto de renda do ano anterior 2021/2020
            </Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={declaracaoAnterior === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={declaracaoAnterior === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={declaracaoAnterior === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={informesRendimentos}
              setValue={setInformesRendimentos}
            />

            <Question>
              Informes de rendimentos de salário, prolabore, distribuição de
              lucros, aluguéis e demais origens de 2021
            </Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={informesRendimentos === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={informesRendimentos === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={informesRendimentos === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={informesBancarios}
              setValue={setInformesBancarios}
            />
            <Question>
              Informes bancário(s) de contas(s) correntes(s) e aplicação(ões)
              referentes ao ano fiscal 2021
            </Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={informesBancarios === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={informesBancarios === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={informesBancarios === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={notasCorretagem}
              setValue={setNotasCorretagem}
            />
            <Question>
              Notas de corretagem e controle dos investimentos em bolsa de
              valores seja eles variáveis ou fixos no ano fiscal 2021
            </Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={notasCorretagem === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={notasCorretagem === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={notasCorretagem === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={bensAutomovel}
              setValue={setBensAutomovel}
            />
            <Question>
              Bens patrimoniais - Automóvel (DUT ou Nota fiscal)
            </Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={bensAutomovel === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={bensAutomovel === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={bensAutomovel === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={bensImovel}
              setValue={setBensImovel}
            />
            <Question>
              Bens patrimoniais - Imóvel (Escritura ou contrato comercial de
              compra)
            </Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={bensImovel === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={bensImovel === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={bensImovel === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={bensParticipacao}
              setValue={setBensParticipacao}
            />
            <Question>Bens patrimoniais - Participação societária</Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={bensParticipacao === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={bensParticipacao === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={bensParticipacao === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={comprovanteEndereco}
              setValue={setComprovanteEndereco}
            />
            <Question>
              Comprovante de endereço, nota fiscal de energia, nota fiscal de
              água ou nota fiscal de conta telefonica
            </Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={comprovanteEndereco === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={comprovanteEndereco === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={comprovanteEndereco === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={dependentes}
              setValue={setDependentes}
            />
            <Question>
              Dependentes (Filhos, pais, cônjuges e etc) pessoas dependentes
              financeiros do declarantes. - Documentos (que possua nome
              completo, CPF e data de nascimento)
            </Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={dependentes === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={dependentes === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={dependentes === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={despesas}
              setValue={setDespesas}
            />
            <Question>
              Despesas com instruções do declarante e dos
              dependentes/alimentando;
            </Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={despesas === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={despesas === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={despesas === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={reciboPagamentos}
              setValue={setReciboPagamentos}
            />
            <Question>
              Recibo de pagamentos efetuados para médicos, dentistas,
              psicólogos, fisioterapeutas, hospitais, clinicas, laboratórios e
              planos de saúde.
            </Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={reciboPagamentos === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={reciboPagamentos === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={reciboPagamentos === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={contribuicao}
              setValue={setContribuicao}
            />
            <Question>
              Contribuição às entidades de previdência privada
            </Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={contribuicao === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={contribuicao === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={contribuicao === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={doacao}
              setValue={setDoacao}
            />
            <Question>
              Doação - Estatuto da criança e incentivo à Cultura
            </Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={doacao === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={doacao === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={doacao === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={comprovanteReceitas}
              setValue={setComprovanteReceitas}
            />
            <Question>
              Comprovante das receitas/despesas de aluguéis de imóveis locados
            </Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={comprovanteReceitas === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={comprovanteReceitas === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={comprovanteReceitas === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={pensao}
              setValue={setPensao}
            />
            <Question>Pensão Alimentícia Judicial</Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={pensao === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={pensao === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={pensao === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={carneLeao}
              setValue={setCarneLeao}
            />
            <Question>Comprovante de pagamento do Carnê Leão</Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={carneLeao === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={carneLeao === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={carneLeao === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CustomRadio
              options={['Sim', 'Não']}
              value={dadosPessoais}
              setValue={setDadosPessoais}
            />
            <Question>Dados pessoais - RG ou CNH e Título de eleitor</Question>
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={dadosPessoais === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Arquivo
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={dadosPessoais === 'Não'}
              onClick={() => setOpenModalDocs(!openModalDocs)}
              className={classes.margin}
            >
              Visualizar
            </Button>

            <Button
              variant="contained"
              color="primary"
              component="span"
              size="small"
              disabled={dadosPessoais === 'Não'}
              onClick={() => setOpenModalUpload(!openModalUpload)}
              className={classes.margin}
            >
              Excluir
            </Button>
          </div>
        </Container>

        <Container>
          <Question>Gasto médio anual em cartões de crédito</Question>

          <TextField
            variant="outlined"
            label="Valor Cartão de Crédito"
            placeholder="R$"
          />
        </Container>

        <Container>
          <Question>Dados bancários para restituição de imposto</Question>
          <div className={classes.root}>
            <TextField variant="outlined" label="Banco" />
            <TextField variant="outlined" label="Agência" />
            <TextField variant="outlined" label="Conta" />
          </div>
        </Container>

        <Button
          size="large"
          variant="contained"
          style={{
            backgroundColor: XMEI_PRIMARY_COLOR,
            color: '#FFF',
            marginTop: 10,
            marginLeft: 10,
            marginBottom: 30,
          }}
          type="submit"
        >
          Enviar
        </Button>
      </form>

      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={openModalUpload}
        onClose={() => setOpenModalUpload(!openModalUpload)}
      >
        <div className={classes.paper2}>
          <Upload
            idServico={idServico}
            // addFile={saveAttachement}
            setClose={() => setOpenModalUpload(!openModalUpload)}
          />
        </div>
      </Modal>

      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={openModalDocs}
        onClose={() => setOpenModalDocs(!openModalDocs)}
      >
        <div className={classes.paper2}>
          <Documents
            idServico={idServico}
            // addFile={saveAttachement}
            setClose={() => setOpenModalDocs(!openModalDocs)}
          />
        </div>
      </Modal>
    </>
  );
}

export default DocumentosIRPF;
